<template>
  <hm-content title>
    <div class="flex mb20 flex-between">
      <div class="flex item-center">
        <el-button type="primary" size="small" @click="addthirdPartySign"
          >添加第三方签约</el-button
        >
      </div>
      <div class="flex flex-end">
        <el-select
          size="small"
          class="mr10"
          placeholder="小程序二维码版本"
          v-model="version"
          style="width: 200px"
          filterable
          @change="envVersionListChange"
        >
          <el-option
            v-for="(item, i) in envVersionList"
            :key="i"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </div>
    <el-table
      :data="list"
      style="width: 100%"
      ref="table"
      stripe
      border
      size="small"
    >
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="序号"
        width="50"
        :index="(index) => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="第三方名称"
        prop="companyName"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="第三方公司名称"
        prop="contractName"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="关联银行卡"
        prop="mchConfigId"
      >
        <template slot-scope="scope">
            <el-select
              size="small"
              clearable
              class="mr10"
              placeholder="关联银行卡"
              v-model="scope.row.mchConfigId"
              filterable
              disabled
              style="width:200px"
            >
              <el-option
                v-for="(item, i) in bankCardList"
                :key="i"
                :label="item.sendName"
                :value="item.id"
              ></el-option>
            </el-select>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="启用状态"
        prop="enabledState"
      >
      <template slot-scope="scope">
          <div class="flex flex-center">
            <span class="success" v-if="scope.row.enabledState ==='yes'">开启</span>
            <span class="danger" v-else>关闭</span>
          </div>
      </template>
      </el-table-column>      
      <el-table-column
        label="操作"
        header-align="center"
        align="center"
        width="300"
      >
        <template slot-scope="scope">
          <div class="flex flex-center">
            <el-button size="small" type="text" @click="edit(scope.row)"
              >编辑</el-button
            >
            <el-button size="small" type="text" @click="record(scope.row)"
              >查看签约记录</el-button
            >            
            <el-button size="small" type="text" @click="productQrcode(scope.row)"
              >生成签约码({{versionLabel}})</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @size-change="handleSizeChange"
        @current-change="paging"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="800px"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="200px"
      >
        <div>
          <el-form-item class="mb10" label="签约名称:" prop="contractCompanyId">
            <el-select
              size="small"
              clearable
              class="mr10"
              placeholder="签约名称"
              v-model="ruleForm.contractCompanyId"
              filterable
              @change="companyNameChange"
            >
              <el-option
                v-for="(item, i) in companyNameList"
                :key="i"
                :label="item.companyName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="mb10" label="签约公司名称:" prop="contractName">
            <el-input
              clearable
              v-model.trim="ruleForm.contractName"
              placeholder="请输入签约公司名称"
              size="small"
              class="ipt mr10"
            ></el-input>
          </el-form-item>
          <el-form-item label="合同内容:">
            <el-input
              size="small"
              v-model="ruleForm.contractDocPath"
              type="textarea"
              placeholder="请输入合同内容"
              style="width: 380px"
              :rows="4"
            ></el-input>
          </el-form-item>
          <el-form-item class="mb10" label="关联银行卡:" prop="mchConfigId">
            <el-select
              size="small"
              clearable
              class="mr10"
              placeholder="关联银行卡"
              v-model="ruleForm.mchConfigId"
              filterable
            >
              <el-option
                v-for="(item, i) in bankCardList"
                :key="i"
                :label="item.sendName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="mb10" label="启用状态:" prop="enabledState">
            <el-switch
              v-model="ruleForm.enabledState"
              active-text="开启"
              inactive-text="关闭"
              active-color="#13ce66"
              active-value="yes"
              inactive-value="no"
            ></el-switch>
          </el-form-item>
        </div>
        <div class="flex flex-center">
          <el-button
            type="primary"
            size="small"
            @click="submitForm('ruleForm', addOrEdit)"
            >保存</el-button
          >
          <el-button size="small" @click="dialogVisible = false"
            >取消</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      title="请用微信扫一扫"
      :visible.sync="qrcodeDialogVisible"
      :modal="false"
      width="250px"
    >
      <div class="qrcode-wrapper">
        <img :src="activityCode" alt="二维码" />
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import area from "@/utils/area";
import { getLoginUser,getUserName } from "@/utils/auth";
export default {
  components: {},
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      title: "添加第三方签约",
      ruleForm: {
        bizType: "redpackage",
        useScene: "contract",
        companyName: "",
        contractName: "",
        contractDocPath: "",
        mchConfigId: "",
        enabledState: "yes",
        contractCompanyId: "",
        companyCode: "",
      },
      bankCardList: [],
      rules: {
        contractCompanyId: {
          required: true,
          message: "请关联签约名称"
        },
        contractName: {
          required: true,
          message: "请输入签约公司名称"
        },
        mchConfigId: {
          required: true,
          message: "请关联银行卡"
        },
      },
      addOrEdit: "",
      currentRow: {},
      companyNameList: [],
      qrcodeDialogVisible: false,
      activityCode: "",
      envVersionList: [
        {
          label: "正式版",
          value: "release",
        },
        {
          label: "开发版",
          value: "develop",
        },
        {
          label: "体验版",
          value: "trial",
        }
      ],
      version: "release",
      versionLabel: "正式版"
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.queryListBankCardList();
    this.queryList();
    this.ThirdCompanyInfoQueryPageList();
  },
  methods: {
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const { result } = await this.$store.dispatch(
        "thirdContractCompanyInfoQueryPageList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async addthirdPartySign() {
      this.addOrEdit = "add";
      this.dialogVisible = true;
      this.title = "添加第三方签约";
      this.ruleForm = {
        bizType: "redpackage",
        useScene: "contract",
        companyName: "",
        contractName: "",
        contractDocPath: "",
        mchConfigId: "",
        enabledState: "yes",
        contractCompanyId: "",
        companyCode: "",
        bizPriority: "9",
      };
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let name = "";
          let params = JSON.parse(JSON.stringify(this[formName]));
          if (this.addOrEdit === "add") {
            name = "thirdContractCompanyInfoAdd";
          } else if (this.addOrEdit === "edit") {
            name = "thirdContractCompanyInfoEdit";
            Object.assign(params, {
              id: this.currentRow.id,
            });
          }
          this.$store.dispatch(name, params).then((res) => {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.queryList();
            this.dialogVisible = false;
          });
        }
      });
    },
    async edit(row) {
      this.addOrEdit = "edit";
      this.title = "编辑第三方签约";
      this.currentRow = row;
      this.ruleForm.companyName = row.companyName;
      this.ruleForm.contractName = row.contractName;
      this.ruleForm.contractDocPath = row.contractDocPath;
      this.ruleForm.mchConfigId = row.mchConfigId;
      this.ruleForm.enabledState = row.enabledState;
      this.ruleForm.contractCompanyId = row.contractCompanyId;
      this.ruleForm.companyCode = row.companyCode;
      this.dialogVisible = true;
    },
    record(row) {
      let id = row.contractCompanyId;
      this.$router.push({
        name: "ThirdPartySignRecord",
        query: {
          id,
        },
      });
    },

    async queryListBankCardList(type) {
      let params = {
        pageSize: 9999,
        pageNo: 1,
        type,
      };
      const { result } = await this.$store.dispatch(
        "getcashQueryPageList",
        params
      );
      const { records, total } = result;
      this.bankCardList = records;
    },
    async ThirdCompanyInfoQueryPageList() {
      let params = {};
      const { result } = await this.$store.dispatch(
        "ThirdCompanyInfoQueryPageList",
        params
      );
      const { records } = result;
      this.companyNameList = records;
    },
    companyNameChange(e){      
      this.companyNameList.forEach(v=>{
        if(v.id === e){
          this.ruleForm.companyName = v.companyName;
          this.ruleForm.companyCode = v.companyCode;
        }
      })
      console.log("this.ruleForm:",this.ruleForm);
    },
    async productQrcode(row) {
      console.log("row:",row);
      const { storeCode,exportId } = getLoginUser();
      const getLoginUser2 = getLoginUser();
      console.log("getLoginUser2:",getLoginUser2);
      const qrcodeContent = JSON.stringify(row);
      const { result } = await this.$store.dispatch("saveQrcodeDataReturnImg", {
        path: `guider/agreement`,
        bizType: "inviteGuiderContract",
        expireDateNum: "2",
        expireMode: "expireDateNum",
        expireType: "temp",
        genQrcodeUserId: exportId,
        genQrcodeUserType: "employeeId",
        qrcodeContent: qrcodeContent,
        qrcodeType: "inviteCode",
        storeCode: '44444444444444',
        systemCode: "redpackage",
        updateOverrideMode: "todayDifferent",
        useScene: "contract",
        genAppid: "-",
        scanAppid: "wxb6312be18f233c71",
        env_version: this.version,
      });
      this.qrcodeDialogVisible = true;
      this.activityCode = result.qrcodeMappingImg;
    },
    envVersionListChange(e){
      this.envVersionList.forEach(v=>{
        if(e===v.value){
          this.versionLabel = v.label;
        }
      })
      console.log("this.version:",this.version);
      console.log("this.versionLabel:",this.versionLabel);
    },
  },
};
</script>
<style lang="scss" scoped>
.red {
  color: #e50065;
}
.qrcode-wrapper {
  img {
    width: 100%;
  }
}
</style>
